const SyndicationDomains = () => import('@/views/Publisher/SyndicationDomains/List.vue');
const SyndicationDomainForm = () => import('@/views/Publisher/SyndicationDomains/Form.vue');

const routes = [
  {
    path: '/syndication-domains',
    component: SyndicationDomains,
    name: 'syndication-domains',
    meta: {
      roles: ['publisher'],
      title: 'Syndication domains',
      icon: 'hp-link',
      alias: 'sd',
    },
  },
  {
    path: '/syndication-domains/add',
    component: SyndicationDomainForm,
    name: 'syndication-domain-form',
    hidden: true,
    meta: {
      roles: ['publisher'],
      title: 'Add syndication domain',
      icon: 'hp-sites',
      alias: 'sd:a',
    },
  },
  {
    path: '/syndication-domains/:id',
    component: SyndicationDomainForm,
    name: 'syndication-domain-edit',
    hidden: true,
    meta: {
      roles: ['publisher'],
      title: 'Edit syndication domain',
      icon: 'hp-sites',
    },
  },
];

export default routes;
